import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  makeStyles,
} from '@fluentui/react-components';
import { brandName } from '@gandhi/mail-protocol';
import { useEffect, useState, type ReactElement } from 'react';
import { pendingOutbox } from '../state/mail-store.js';
import { useController, useMail } from '../state/context.js';

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    bottom: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    minWidth: '360px',
    zIndex: 100,
  },
});

/** Undo send. The message is still in the outbox; cancelling stops it, not recalls it. */
export function UndoSendBar(): ReactElement | null {
  const styles = useStyles();
  const controller = useController();
  const outbox = useMail((s) => s.outbox);
  const pending = pendingOutbox({ ...controller.state, outbox });
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(timer);
  }, []);

  const entry = pending[0];
  if (entry === undefined) return null;
  const remaining = Math.max(0, Math.ceil((Date.parse(entry.sendAt) - now) / 1000));

  return (
    <div className={styles.root}>
      <MessageBar intent="info" data-testid="undo-send">
        <MessageBarBody>
          Sending as {brandName(entry.brandId)} from {entry.from.address}
          {remaining > 0 ? ` in ${remaining}s` : ' now'}.
        </MessageBarBody>
        <MessageBarActions>
          <Button
            size="small"
            appearance="primary"
            data-testid="undo-send-button"
            onClick={() => void controller.undoSend(entry.id)}
          >
            Undo
          </Button>
        </MessageBarActions>
      </MessageBar>
    </div>
  );
}
